<template>
  <div class="container">
	  <div class="adminContent d-flex j-end">
		  <!-- 左侧菜单 -->
		  <div :class="['leftMenu', {active: handleType}]">
			  <figure @click="goToPage('/loginHome')" class="t-center pointer"><img src="@/assets/Admin/mlogo.svg" alt=""></figure>
			  <ul>
				  <li @click="goToPage(item.url)" v-for="(item, index) in menuList" :key="index" :class="['font18', {active: current(item.url)}]"><a href="javascript:;">{{item.column}}</a></li>
			  </ul>
		  </div>
		  
		  <!-- 右侧内容 -->
		  <!-- 移动端显示分类 -->
		  <div :class="['handleType a-center j-center', {active: handleType}]" @click="handleType = !handleType">{{handleType ? $t('commom.close') : $t('commom.menu')}}<img src="@/assets/Icons/type.svg" alt="" /></div>
		  <div class="rightCotnent">
			  <div class="topHandle d-flex j-sb a-center">
				  <div class="avatar d-flex a-center" @click="goToPage('/personInformation')">
					  <figure :style="'background-image: url('+$store.state.avatar+')'"></figure>
					  <p><span class="cor265">{{$store.state.member.sexual}}{{$store.state.member.name}}</span>，{{$t('admin.slogan')}}！</p>
				  </div>
				  <div class="tonic d-flex">
					   <div @click="goToPage('/loginHome')" class="icon pointer home" :title="$t('admin.website')"></div>
					  <div @click="goToPage('/messageList')" class="icon pointer info" :title="$t('admin.messageCenter')"></div>
					  <div @click="exit" class="icon pointer exit" :title="$t('admin.exit')"></div>
				  </div>
			  </div>
			  <el-tabs  type="card" closable>
				<el-tab-pane v-for="(item, index) in tabs" :key="index"
					:label="item.column"
					:name="item.id">
					
				</el-tab-pane>
			  </el-tabs>
			  <!-- 面包屑 -->
			 <!-- <div class="position">
					<ul class="d-flex">
					  <li @click.stop="goToPage(item.path)" v-for="(item, index) in breadcrumb" :key="index" class="pointer t-sion">{{item.name}}<span @click.stop="closePath(index)" v-show="index > 0"></span></li>
					</ul>
			  </div> -->
			  <!-- 路由 -->
			  <router-view></router-view>
		  </div>
	  </div>
  </div>
</template>

<script>
// vuex
import { mapMutations } from 'vuex'
export default {
  name: 'Admin',
  components: {
    
  },
  data() {
    return {
		// 控制移动端分类的显示/隐藏
		handleType: false,
		// 菜单
		menuList: [
			{id: 0, column: this.$t('adminMenu.home'), url: '/admin'},
			{id: 1, column: this.$t('adminMenu.information'), url: '/personInformation'},
			{id: 2, column: this.$t('adminMenu.password'), url: '/changePassword'},
			{id: 3, column: this.$t('adminMenu.product'), url: '/myProduct'},
			{id: 4, column: this.$t('adminMenu.download'), url: '/downloadHistory'},
			//{id: 5, column: this.$t('adminMenu.entry'), url: '/enterHistory'},
			{id: 6, column: this.$t('adminMenu.feedback'), url: '/problemFeedback'}
		],
		tabs:[],
		 // 面包屑数据
		 breadcrumb: {}
	}
  },
  
  computed: {
  	  // 导航当前样式
  	  current: function() {
  		  return function(url) {
			  if(this.$route.path == '/enterDetail') {
				return url.indexOf('enter') >= 0 ? true : false;
			  }
			  if(this.$route.path == '/problemDetail') {
			  	return url.indexOf('problem') >= 0 ? true : false;
			  }
			  if(this.$route.path == '/ipProjectList' || this.$route.path == '/ipProductDetail') {
			  	return url.indexOf('ipProduct') >= 0 ? true : false;
			  }
  			  return this.$route.path.indexOf(url) >= 0 ? true : false;
  			 
  		  }
  	  }
  },
  
  created() {
	  this.breadcrumb = this.$route.matched;
  },
  
  methods: {
	  // vuex
	  ...mapMutations(['changeState']),
	  
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  		  	path,
  			query
  		  })
  	  },
	  
	  // 退出登录
	  exit() {
		  // 清除Token
		  localStorage.removeItem("Authorization");
		  // 清除存储用户信息
		  localStorage.removeItem("member");
		  // 清除登录
		  localStorage.removeItem("isLogin");
		  //清除权限信息
		  localStorage.removeItem("permissions");
		  //清除过期信息
		  localStorage.removeItem("isUpdatePassword");
		  // 修改store
		  this.changeState({
		  	member: {
				sexual: '',
				name: ''
			},
		  	isLogin: ''
		  });
		  this.$message.success(this.$t('admin.exit'));
		  this.$router.push('/login');
	  },
	  
	  // 删除面包屑
	  closePath(index) {
		  if(index == 0) return;
		  this.breadcrumb.splice(index, 1);
		  this.$router.push(this.breadcrumb[index-1].path);
	  }
  },
  
  // 监听
  watch: {
  	  // 路由变化
  	  '$route'(to, from) {
  		  // 重新获取面包屑
  		  this.breadcrumb = this.$route.matched;
  	  } 
  }
}
</script>

<style lang="less" scoped>
	.container{
		background: #f2f5fa;
	}
	.personHome{
		padding: .4rem;
	}
	.handleType{
		transition: all .5s;
		bottom: .2rem;
		&.active{
			left: 250px;
		}
		
	}
	.position{
		background: #fff;
		overflow-x: auto;
		width: 100%;
		ul{
			white-space: nowrap;
			li{
				position: relative;
				white-space: nowrap;
				display: inline-block;
				padding: 0 .3rem 0 .2rem;
				height: .4rem;
				line-height: .4rem;
				&:hover{
					background: #f1f1f1;
				}
				
				span{
					position: absolute;
					right: 0;
					top: 0;
					width: .3rem;
					height: 100%;
					background: url(@/assets/Icons/closeNew.png) no-repeat center/.1rem;
					&:hover{
						background-image: url(@/assets/Icons/closeBlue.png);
					}
				}
			}
		}
	}
	.adminContent{
		.rightCotnent{
			width: calc(100% - 240px);
			padding-top: .7rem;
			min-height: 100vh;
			.topHandle{
				position: fixed;
				top: 0;
				right: 0;
				padding: 0 .4rem;
				width: calc(100% - 240px);
				background: #fff;
				border-bottom: solid 1px #eee;
				background: #fff;
				z-index: 2;
				figure{
					width: .4rem;
					height: .4rem;
					border-radius: 50%;
					background: url(@/assets/Admin/avatar.png) no-repeat center/cover;
					margin-right: .1rem;
				}
			}
			.tonic{
				.icon{
					height: .7rem;
					width: .6rem;
					img{
						width: .18rem;
					}
				}
				.info{
					background: url(@/assets/Icons/tonic.png) no-repeat center/.18rem;
				}
				.exit{
					background: url(@/assets/Icons/exit.png) no-repeat center/.18rem;
					&:hover{
						background-image: url(@/assets/Icons/exitBlue.png);
					}
				}
				.home{
					background: url(@/assets/Icons/home.svg) no-repeat center/.22rem;
					&:hover{
						background-image: url(@/assets/Icons/homeHover.svg);
					}
				}
			}
		}
		.leftMenu{
			position: fixed;
			left: 0;
			top: 0;
			z-index: 15;
			width: 240px;
			height: 100vh;
			background: #fff;
			border-right: solid 1px #eee;
			overflow: auto;
			padding-bottom: .5rem;
			>figure{
				padding: .4rem 0 .3rem;
				img{
					width: .9rem;
				}
			}
			ul{
				
				li{
					&:not(:last-child) {
						border-bottom: solid 1px #eee;
					}
					&:nth-of-type(1) a{
						background: url(@/assets/Icons/personIcon15.png) no-repeat .3rem center/auto .2rem, url(@/assets/Icons/arrowRightGray.png) no-repeat 92% center/.08rem;
					}
					&:nth-of-type(2) a{
						background: url(@/assets/Icons/personIcon1.png) no-repeat .3rem center/auto .2rem, url(@/assets/Icons/arrowRightGray.png) no-repeat 92% center/.08rem;
					}
					&:nth-of-type(3) a{
						background: url(@/assets/Icons/personIcon2.png) no-repeat .3rem center/auto .2rem, url(@/assets/Icons/arrowRightGray.png) no-repeat 92% center/.08rem;
					}
					&:nth-of-type(4) a{
						background: url(@/assets/Icons/personIcon3.png) no-repeat .3rem center/auto .2rem, url(@/assets/Icons/arrowRightGray.png) no-repeat 92% center/.08rem;
					}
					&:nth-of-type(5) a{
						background: url(@/assets/Icons/personIcon4.png) no-repeat .3rem center/auto .2rem, url(@/assets/Icons/arrowRightGray.png) no-repeat 92% center/.08rem;
					}
					&:nth-of-type(6) a{
						background: url(@/assets/Icons/personIcon5.png) no-repeat .3rem center/auto .2rem, url(@/assets/Icons/arrowRightGray.png) no-repeat 92% center/.08rem;
					}
					&:nth-of-type(7) a{
						background: url(@/assets/Icons/personIcon6.png) no-repeat .3rem center/auto .2rem, url(@/assets/Icons/arrowRightGray.png) no-repeat 92% center/.08rem;
					}
					&:nth-of-type(8) a{
						background: url(@/assets/Icons/personIcon7.png) no-repeat .3rem center/auto .2rem, url(@/assets/Icons/arrowRightGray.png) no-repeat 92% center/.08rem;
					}
					&.active,&:hover{
						a{
							background-color: #2657db;
							color: #fff;
						}
						&:nth-of-type(1) a{
							background-image: url(@/assets/Icons/personIcon16.png);
						}
						&:nth-of-type(2) a{
							background-image: url(@/assets/Icons/personIcon8.png);
						}
						&:nth-of-type(3) a{
							background-image: url(@/assets/Icons/personIcon9.png);
						}
						&:nth-of-type(4) a{
							background-image: url(@/assets/Icons/personIcon10.png);
						}
						&:nth-of-type(5) a{
							background-image: url(@/assets/Icons/personIcon11.png);
						}
						&:nth-of-type(6) a{
							background-image: url(@/assets/Icons/personIcon12.png);
						}
						&:nth-of-type(7) a{
							background-image: url(@/assets/Icons/personIcon13.png);
						}
						&:nth-of-type(8) a{
							background-image: url(@/assets/Icons/personIcon14.png);
						}
					}
					a{
						display: block;
						height: .7rem;
						line-height: .7rem;
						text-indent: .5rem;
						padding: 0 .3rem;
					}
				}
			}
		}
		@media (max-width: 1200px) {
			.leftMenu{
				left: -240px;
				transition: all .5s;
				&.active{
					left: 0;
				}
			}
			.rightCotnent{
				width: 100%;
				.topHandle{
					width: 100%;
					padding: 0 2.5%;
				}
			}
		}
	}
</style>
